module.exports = __webpack_public_path__ + "static/media/HOW TO CREATE OR ADD AN EMPLOYER FILE.4c54205d.png";